import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { TENANT_SCHEMA_QUERY_KEY } from '@diggens/shared-hooks';
import { activateAppVersion, disableAppVersion, fetchInstalledApps } from './api';

export const INSTALLED_APPS_QUERY_KEY = ['installed-apps'] as const;

export function useInstalledApps(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: INSTALLED_APPS_QUERY_KEY,
    queryFn: fetchInstalledApps,
    enabled: options.enabled ?? true,
  });
}

/** After a version goes live or is switched off, both the list and the tenant schema (menus, routes) are stale. */
function useRefreshAfterChange() {
  const queryClient = useQueryClient();
  return async () => {
    await Promise.all([queryClient.invalidateQueries({ queryKey: INSTALLED_APPS_QUERY_KEY }), queryClient.invalidateQueries({ queryKey: TENANT_SCHEMA_QUERY_KEY })]);
  };
}

export function useActivateAppVersion() {
  const refresh = useRefreshAfterChange();
  return useMutation({ mutationFn: activateAppVersion, onSuccess: refresh });
}

export function useDisableAppVersion() {
  const refresh = useRefreshAfterChange();
  return useMutation({ mutationFn: disableAppVersion, onSuccess: refresh });
}
